import type { FC } from 'react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { BiData, AddDiscountClickBiEvent } from '@wix/da-bi/pkg/events';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import AddIcon from '@wix/da-ds/pkg/Icons/24x24/Add';
import SellerDiscountModal from '../../../../shop/SellerDiscounts/SellerDiscountModal';

interface Props {}

const CreateDiscountButton: FC<Props> = () => {
  const { t } = useTranslation();
  const [isModalOpen, setIsModalOpen] = useState(false);
  return (
    <>
      <TextButton
        size="medium"
        variant="main"
        priority="primary"
        icon={AddIcon}
        iconProps={{ disableDefaultColors: true }}
        onClick={() => setIsModalOpen(true)}
        biData={BiData<AddDiscountClickBiEvent>({
          evid: 450,
          sectionname: 'header',
        })}
      >
        {t('studio.header.tabs.discounts.addDiscount')}
      </TextButton>
      {isModalOpen && (
        <SellerDiscountModal onRequestClose={() => setIsModalOpen(false)} />
      )}
    </>
  );
};
CreateDiscountButton.displayName = 'CreateDiscountButton';

export default CreateDiscountButton;
